import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleKindQuery, SaleKindQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleKindQuery)
@Wrapper(SaleKindQueryHandlerBase)
export class SaleKindQueryHandler {
    public constructor(
        http: Http
    ) { }
}
